const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactnforesume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.21,28.53A32.51,32.51,0,0,0,28,35.26a27.67,27.67,0,0,0,7.61,5.62.81.81,0,0,0,.66,0,2.78,2.78,0,0,0,.92-.66,11.08,11.08,0,0,0,.83-1c1.23-1.61,2.74-3.6,4.88-2.6l.13.06,7.13,4.1.06,0a3.23,3.23,0,0,1,1.34,2.78,7.49,7.49,0,0,1-1,3.53,7.22,7.22,0,0,1-3.43,3,15.36,15.36,0,0,1-4.23,1.15,14.42,14.42,0,0,1-6.46-.53,28.82,28.82,0,0,1-6.49-3.14l-.17-.11c-1.06-.66-2.2-1.36-3.32-2.19a41.65,41.65,0,0,1-11-12.47c-2.27-4.12-3.52-8.57-2.84-12.82a9.2,9.2,0,0,1,3.12-5.83,8.28,8.28,0,0,1,6.2-1.66.91.91,0,0,1,.72.46l4.57,7.73a2.41,2.41,0,0,1,.38,2.59,5,5,0,0,1-1.75,2c-.24.21-.53.42-.84.64-1,.74-2.19,1.6-1.79,2.61v0Z",
    id: "id_103",
    style: {
      fill: "rgb(255, 23, 23)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactnforesume);
export default __webpack_public_path__ + "static/media/contactnforesume.15adaa9743529da89e1c8979172ecd49.svg";
export { ForwardRef as ReactComponent };